// todo fix: process is not defined
if (typeof process === 'undefined' || typeof window.process === 'undefined') {
  window.process = {
    env: {
      NODE_ENV: 'production'
    }
  }
}
